export const AUTHED_APP = 'AuthedApp';
export const PHONE_SUPPORT = 'PhoneSupport';
export const INTEGRATION_TEST = 'IntegrationTest';
export const BREEZE_INTELLIGENCE_PAGE = 'BreezeIntelligencePage';
export const BREEZE_INTELLIGENCE_STARTER_PLATFORM_CARD = 'BreezeIntelligenceStarterPlatformCard';
export const RECOMMENDED_PAGE = 'RecommendedPage';
export const SMART_CRM_PAGE = 'SmartCrmPage';
export const SMART_CRM_PAGE_CONTENT = 'SmartCrmPageContent';
export const MARKETING_PLUS_PAGE = 'MarketingPlusPage';
export const MARKETING_PLUS_PAGE_CONTENT = 'MarketingPlusPageContent';
export const BUNDLE_PAGE = 'BundlePage';
export const SUITE_PAGE = 'SuitePage';
export const SUITE_PAGE_CONTENT = 'SuitePageContent';
export const PRODUCT_PAGE = 'ProductPage';
export const PRODUCT_PAGE_CONTENT = 'ProductPageContent';
export const ADD_ONS_PAGE = 'AddOnsPage';
export const COMMERCE_PAGE = 'CommercePage';
export const COMMERCE_HUB_PAGE_CONTENT = 'CommerceHubPageContent';
export const FREE_TOOLS_PAGE = 'FreeToolsPage';
export const FREE_TOOLS_PAGE_CONTENT = 'FreeToolsPageContent';
export const MISSING_INFO_FALLBACK_PAGE = 'MissingInfoFallbackPage';
export const COMPARE_PLANS_LINK = 'ComparePlansLink';